import "@zebra-fed/icons/Enterprise/index.css";
import React, {useEffect, useRef, useContext} from "react";
import {useHistory} from "react-router";
import {useLocation} from "react-router-dom";
import styled from "styled-components";
import {useTranslation} from 'react-i18next'

import {ContentWrapper} from "../../../styled-components/shared";

import {DeviceCardsContainer} from "./DeviceCardsContainer";
import {DashboardFilters} from "./dashboard-filters";
import {DeviceSummaryPopupComponent} from "../Components/DeviceSummaryPopupComponent";
import {useDashboardContext} from "../context/dashboard.context";
import {useDashboardFiltersContext} from "../context/dashboard-filter.context";
import { userJustManager } from "../../../data/userUtil";
import { AuthContext } from "../../../authentication/Auth";
import { fetchDevicesCount } from "../../../data/FirebaseUtil";



const DashboardFiltersContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0px 24px 0px;
  align-items: center;
`

export default function SummaryContainer({...props}) {
  const history = useHistory()
  const context = useContext(AuthContext);
  const {sitevalue, setTitle} = props
  const location = useLocation()
  const deviceSummary = useRef(null)
  const isManager = userJustManager(context.currentUser.claims);
    const {t} = useTranslation();

  const {setAvailableCount, setInUseCount, setMissingCount, setSelectedCard, isLoading, setIsLoading} =
    useDashboardContext();
  const { selectedCabinets, filterSelection, setCurrentPage } = useDashboardFiltersContext();

  useEffect(() => {
    if (localStorage) {
      localStorage.removeItem('firebase:previous_websocket_failure')
    }
    if (sessionStorage.getItem('selectedTile')) {
      let deviceSearchObject = JSON.parse(
        sessionStorage.getItem('selectedTile')
      )
      setTitle(deviceSearchObject)
      history.push({
        pathname: location.pathname,
        state: {
          deviceSearchObject: deviceSearchObject,
          selectedSitevalue: sessionStorage.getItem('selectedSite')
            ? sessionStorage.getItem('selectedSite')
            : sitevalue
        }
      })
    }
  }, [])

  useEffect(() => {
    if (selectedCabinets.length > 0) {
      getDashbordCount();
    }
  }, [filterSelection])

  const getDashbordCount = async () => {
    setIsLoading(true);
    const requestedKiosks = selectedCabinets?.length
        ? selectedCabinets.map((e) => e.value)
        : !isManager
        ? ["select-all"]
        : [];
    const deviceCountResult = await fetchDevicesCount({tenantName:context.currentUser.claims.companyID, kiosks:requestedKiosks})
                              .catch((error) =>  setIsLoading(false)); 
    const deviceCount = deviceCountResult?.data                          
    setAvailableCount(deviceCount?.available || 0);
    setInUseCount(deviceCount?.inUse || 0);
    setMissingCount(deviceCount?.missing || 0);
    setIsLoading(false)
  }

  const openDetailPopup = (state) => {
    deviceSummary?.current?.open()
    setSelectedCard(state)
    setCurrentPage("summaryPopup")
  }

  const closeDetailPopup = () => {
    deviceSummary?.current?.close()
  }

  return (
    <>
      <ContentWrapper
        style={{
          cursor: isLoading ? "wait" : "default",
          opacity: isLoading ? "0.4" : "1",
          position: "relative",
          borderRadius: "8px",
          border: "1px solid #ccc"
        }}
      >
        <DashboardFiltersContainer>
          <div>{t("deviceSummary")}</div>
          <DashboardFilters />
        </DashboardFiltersContainer>
        <DeviceCardsContainer
          openDetailPopup={openDetailPopup}
          pageName="dashboard"
        ></DeviceCardsContainer>
        <DeviceSummaryPopupComponent
          modalRef={deviceSummary}
          onClose={closeDetailPopup}
        />
      </ContentWrapper>
    </>
  );
}
